import { ChangeManagementDialogContent } from "@pages/project-details/project-overview/change-management/change-management-dialog-content";
import { useGroupMembersContext } from "@context-providers/group-members-provider";
import { useState, PropsWithChildren } from "react";

/** A dialog to change the project manager and group of the current project */
export function ChangeManagementDialog({
  children,
}: PropsWithChildren): JSX.Element {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const { canChangeManagement } = useGroupMembersContext();

  return (
    <>
      <div
        style={canChangeManagement ? { cursor: "pointer" } : undefined}
        onClick={() => setIsDialogOpen(canChangeManagement)}
      >
        {children}
      </div>
      <ChangeManagementDialogContent
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  );
}
